import React, { PureComponent } from 'react';
import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer
} from '../../components/ui';

import Image from '../../../../containers/assets/peer-feedback-strength-areas-of-development.png'

class FeedbackStep1 extends PureComponent {
  render() {
    return (
      <Wrapper>
        <PreTitle>Feedback</PreTitle>
        <Title>Strengths and Areas of Development</Title>
        <Text>
          <p>Now let’s get a little deeper into the peer feedback and explore the teamwork skills that you’ve been demonstrating in this exercise.</p>
        </Text>
        <ContentContainer>
          <img src={Image} alt='' />
        </ContentContainer>
      </Wrapper>
    );
  }

}

export default FeedbackStep1;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/feedback/step1.js